import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { HasAccess } from '@permify/react-role';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import { getControlRateAll, getControlRateLotteryTypeById, postCreateControlRate } from 'api/controlRate';
import { getCustomerAll, getCustomerMyGroupUserAll } from 'api/customer';
import { getLotteryTypeAll } from 'api/lotteryType';
import { getTypeNumberAll } from 'api/typeNumber';
import { ErrorPage404 } from 'common/Error/error.common';
import { renderSkeletonTable } from 'common/Skeleton';
import { messageRequireIcon } from 'common/messageError/message.common';
import Color from 'constants/color';
import { getCookie } from 'helper/cookie';
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
const { Option } = Select;

type ControlRateType = {
  id: number;
  control_rate_user_id: number;
  control_rate_three_top_price: string;
  control_rate_three_tod_price: string;
  control_rate_two_top_price: string;
  control_rate_two_bottom_price: string;
  control_rate_three_bottom_price: string;
  control_rate_run_top_price: string;
  control_rate_run_bottom_price: string;
};

type ControlRateData = {
  id: number;
  control_rate_lottery_type_id: number;
  control_rate_user_id: number;
  control_rate_three_top_price: number | null;
  control_rate_three_tod_price: number | null;
  control_rate_two_top_price: number | null;
  control_rate_two_bottom_price: number | null;
  control_rate_three_bottom_price: number | null;
  control_rate_run_top_price: number | null;
  control_rate_run_bottom_price: number | null;
};

import styled from 'styled-components';

export const PremiumTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 185, 148, 0.1);
  background-color: #ffffff;
`;

export const PremiumThead = styled.thead`
  background: linear-gradient(to right, #00b894, #0073e6);
  color: #ffffff;
`;

export const PremiumTh = styled.th`
  padding: 14px 12px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  border-bottom: 1px solid #e0f0ff;
`;

export const PremiumSubTh = styled.th`
  background-color: #ecfdfd;
  color: #34495e;
  padding: 10px 8px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  border-bottom: 1px solid #d4f2f0;
`;

export const PremiumTd = styled.td`
  padding: 12px 10px;
  text-align: center;
  color: #34495e;
  font-size: 14px;
  border-bottom: 1px solid #f2f2f2;

  &:hover {
    background-color: #f7fdfd;
  }
`;

export const PremiumRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9fdfd;
  }

  &:hover {
    background-color: #e3fdfc;
  }
`;

const ControlRateCreate = (props?: any) => {
  const { id } = props;
  //  let id: any = null;
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const location = useLocation();
  const locationSplit = location?.pathname.split('/');
  const token = getCookie('access_tokenltl');
  const dataUser: any = getCookie('dataUser');
  const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
  const [form] = Form.useForm();

  // const [isLoadingPeriod, setIsLoadingPeriod] = useState(true);
  const [dataPeriod, setPeriod] = useState<any>([]);

  const [isLoadingControlRate, setIsLoadingControlRate] = useState(true);
  const [dataControlRateData, setControlRateData] = useState<any>([]);

  const [dataLotteryType, setDataLotteryType] = useState<any>([]);
  const [isLoadingDataLotteryType, setIsLoadingDataLotteryType] = useState(false);
  const [lotteryType, setLotteryType] = useState<any>('');

  const [dataCustomer, setDataCustomer] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCustomerList = useCallback(
    async (query?: any) => {
      setIsLoading(true);
      const params = {
        limit: 999,
        offset: 0,
        order_by: 'type',
        order_type: 'DESC',
        // hide:  query?.hide ? query?.hide : null,
        // search: query?.search ? query?.search : null,
        groupuser_id: Number(parseDataUser?.groupuser_id),
        types: ['Senior', 'Master', 'Agent'],
      };
      // console.log(params)
      try {
        const responseData = await getCustomerMyGroupUserAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setDataCustomer(data?.data?.customer);

          setIsLoading(false);
        } else {
          setDataCustomer([]);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    [token],
  );

  useMemo(() => {
    if (token) {
      fetchCustomerList();
    }
  }, [token, fetchCustomerList]);

  const fetchLotteryTypeMyData = useCallback(
    async (query: any) => {
      setIsLoadingDataLotteryType(true);
      const params = {
        ids: parseDataUser?.lottery_type,
      };
      try {
        const responseData = await getLotteryTypeAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          // console.log(data)
          setDataLotteryType(data?.data?.lottery_type);
          setIsLoadingDataLotteryType(false);
        } else {
          setDataLotteryType('');
          setIsLoadingDataLotteryType(false);
        }
      } catch (error) {
        setIsLoadingDataLotteryType(false);
      }
    },
    [token, id],
  );

  useMemo(() => {
    if (token && parseDataUser) {
      fetchLotteryTypeMyData(parseDataUser?.lottery_type);
    }
  }, [token, id]);

  const renderRoles = () => {
    if (isLoadingDataLotteryType === false) {
      return dataLotteryType?.map((value: any, index: number) => {
        if (id) {
          // console.log(dataControlRateData)
          if (dataControlRateData[0]?.control_rate_lottery_type_id === value?.id) {
            return (
              <Option value={value?.id} key={index}>
                {value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)
              </Option>
            );
          }
        } else {
          return (
            <Option value={value?.id} key={index}>
              {value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)
            </Option>
          );
        }
      });
    }
    return [];
  };

  const fetchControlRateData = useCallback(
    async (id?: number) => {
      // console.log(query)
      setIsLoadingControlRate(true);
      const params = {
        control_rate_lottery_type_id: Number(lotteryType ? lotteryType : id),
        order_by: 'control_rate_lottery_type_id',
        order_type: 'ASC',
      };
      try {
        const responseData = await getControlRateLotteryTypeById({ token, params: params });
        if (responseData?.status === 200) {
          // const { data } = responseData;
          const controlRateData = responseData.data?.data || [];
          setControlRateData(controlRateData);
          // console.log(controlRateData)
          // Setting form values for each control rate entry
          // Prepare and set the field values for form initialization
          const fieldValues = controlRateData?.reduce((acc: any, item: any) => {
            // Create a unique field entry for each control rate attribute
            acc[`id_${item.control_rate_user_id}`] = item.id;
            acc[`control_rate_three_top_price_${item.control_rate_user_id}`] = item.control_rate_three_top_price;
            acc[`control_rate_three_tod_price_${item.control_rate_user_id}`] = item.control_rate_three_tod_price;
            acc[`control_rate_two_top_price_${item.control_rate_user_id}`] = item.control_rate_two_top_price;
            acc[`control_rate_two_bottom_price_${item.control_rate_user_id}`] = item.control_rate_two_bottom_price;
            acc[`control_rate_three_bottom_price_${item.control_rate_user_id}`] = item.control_rate_three_bottom_price;
            acc[`control_rate_run_top_price_${item.control_rate_user_id}`] = item.control_rate_run_top_price;
            acc[`control_rate_run_bottom_price_${item.control_rate_user_id}`] = item.control_rate_run_bottom_price;
            return acc;
          }, {});

          form.setFieldsValue(fieldValues);

          // console.log(data)
          // setLotteryType()

          //  controlRateDataArray?.forEach((value: ControlRateType, index: number) => {
          //    const fieldValues = {
          //      [`id_${index}`]: value.id,
          //      [`control_rate_user_id_${index}`]: value.control_rate_user_id,
          //      [`control_rate_three_top_price_${index}`]: value.control_rate_three_top_price,
          //      [`control_rate_three_tod_price_${index}`]: value.control_rate_three_tod_price,
          //      [`control_rate_two_top_price_${index}`]: value.control_rate_two_top_price,
          //      [`control_rate_two_bottom_price_${index}`]: value.control_rate_two_bottom_price,
          //      [`control_rate_three_bottom_price_${index}`]: value.control_rate_three_bottom_price,
          //      [`control_rate_run_top_price_${index}`]: value.control_rate_run_top_price,
          //      [`control_rate_run_bottom_price_${index}`]: value.control_rate_run_bottom_price
          //    };
          //    form.setFieldsValue(fieldValues);
          //  });

          // Optionally set lottery type if needed outside the loop
          const lotteryTypeId = controlRateData[0]?.control_rate_lottery_type_id;
          form.setFieldsValue({ control_rate_lottery_type_id: lotteryTypeId });
          setLotteryType(lotteryTypeId);
          setIsLoadingControlRate(false);
        } else {
          setControlRateData([]);
          setIsLoadingControlRate(false);
        }
      } catch (error) {
        setIsLoadingControlRate(false);
      }
    },
    [token],
  );

  useMemo(() => {
    if (token || id) {
      fetchControlRateData(id);
    }
  }, [token, fetchControlRateData, id]);

  const handleSubmit = async (values: any) => {
    const controlRateLotteryTypeId = lotteryType ? lotteryType : id;
    const params = { control_rate: [] as ControlRateData[] };
    // Ensure you use the correct key based on control_rate_user_id instead of an index-based approach
    dataCustomer?.forEach((customer: any) => {
      const userId = customer.id;
      const formData: any = {
        id: id ? form.getFieldValue(`id_${userId}`) : 0, // Assuming you're correctly setting these hidden fields somewhere
        userId: userId,
        priceThreeTop: form.getFieldValue(`control_rate_three_top_price_${userId}`),
        priceThreeTod: form.getFieldValue(`control_rate_three_tod_price_${userId}`),
        priceTwoTop: form.getFieldValue(`control_rate_two_top_price_${userId}`),
        priceTwoBottom: form.getFieldValue(`control_rate_two_bottom_price_${userId}`),
        priceThreeBottom: form.getFieldValue(`control_rate_three_bottom_price_${userId}`),
        priceRunTop: form.getFieldValue(`control_rate_run_top_price_${userId}`),
        priceRunBottom: form.getFieldValue(`control_rate_run_bottom_price_${userId}`),
      };

      if (Object.values(formData).some(value => value !== null && value !== undefined)) {
        const dataArray: ControlRateData = {
          id: id ? formData.id : 0,
          control_rate_lottery_type_id: controlRateLotteryTypeId,
          control_rate_user_id: formData.userId,
          control_rate_three_top_price: formData.priceThreeTop || null,
          control_rate_three_tod_price: formData.priceThreeTod || null,
          control_rate_two_top_price: formData.priceTwoTop || null,
          control_rate_two_bottom_price: formData.priceTwoBottom || null,
          control_rate_three_bottom_price: formData.priceThreeBottom || null,
          control_rate_run_top_price: formData.priceRunTop || null,
          control_rate_run_bottom_price: formData.priceRunBottom || null,
        };

        params.control_rate.push(dataArray);
      }
    });
    // console.log(params)
    // return false
    const createData = await postCreateControlRate({ token, params: params });
    if (createData.status === 200) {
      Swal.fire({
        icon: 'success',
        title: 'บันทึกข้อมูลสำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
      await fetchControlRateData(id);
      // navigate(`/backoffice/period/edit/${createData?.data?.data?.id}`, { replace: true });
    } else {
      Swal.fire({
        icon: 'error',
        title: createData?.data?.message ? createData?.data?.message : 'บันทึกข้อมูลไม่สำเร็จ',
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

  const renderDataTable = () => {
    if (!isLoading) {
      return (
        <PremiumTable>
          <PremiumThead>
            <tr>
              <PremiumTh>ชื่อ - นามสกุล</PremiumTh>
              <PremiumTh>ยูสเซอร์</PremiumTh>
              <PremiumTh>ระดับสมาชิก</PremiumTh>
              <PremiumTh>3 ตัวบน</PremiumTh>
              <PremiumTh>3 ตัวโค๊ด</PremiumTh>
              <PremiumTh>2 ตัวบน</PremiumTh>
              <PremiumTh>2 ตัวล่าง</PremiumTh>
              <PremiumTh>3 ตัวล่าง</PremiumTh>
              <PremiumTh>วิ่งบน</PremiumTh>
              <PremiumTh>วิ่งล่าง</PremiumTh>
            </tr>
            <tr>
              <PremiumSubTh />
              <PremiumSubTh />
              <PremiumSubTh />
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
              <PremiumSubTh>สูงสุดต่อเลข</PremiumSubTh>
            </tr>
          </PremiumThead>
          <tbody>{renderItem()}</tbody>
        </PremiumTable>
      );
    } else {
      return renderSkeletonTable(4, isLoading, <></>);
    }
  };

  const renderItem = () => {
    return dataCustomer?.map((value: any, index: number) => {
      // console.log(value)
      return (
        <tr key={index}>
          <td align="center" valign="middle" style={{ width: '150px' }}>
            <span style={{ fontWeight: 500 }}>
              {value?.name} {value?.lastname}
            </span>
            <Form.Item name={`control_rate_user_id_${value.id}`} style={{ display: 'none' }} initialValue={value?.id}>
              <Input type="hidden" />
            </Form.Item>
            <Form.Item name={`id_${value.id}`} style={{ display: 'none' }} initialValue={value?.id}>
              <Input type="hidden" />
            </Form.Item>
          </td>
          <td align="center" valign="middle" style={{ width: '150px' }}>
            <span style={{ fontWeight: 500 }}>{value?.username}</span>
          </td>
          <td align="center" valign="middle" style={{ width: '110px' }}>
            <span style={{ fontWeight: 500 }}>{value?.type}</span>
          </td>
          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_three_top_price_${value.id}`}
              initialValue={null}
              rules={[
                {
                  max: 4,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>

          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_three_tod_price_${value.id}`}
              initialValue={null}
              rules={[
                {
                  max: 4,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>

          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_two_top_price_${value.id}`}
              //   name={`control_rate_two_top_price_${index}`}
              initialValue={null}
              rules={[
                {
                  max: 4,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>
          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_two_bottom_price_${value.id}`}
              initialValue={null}
              rules={[
                {
                  max: 4,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>
          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_three_bottom_price_${value.id}`}
              initialValue={null}
              rules={[
                {
                  max: 4,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>
          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_run_top_price_${value.id}`}
              initialValue={null}
              rules={[
                {
                  max: 5,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>
          <td align="center" valign="middle">
            <Form.Item
              name={`control_rate_run_bottom_price_${value.id}`}
              initialValue={null}
              rules={[
                {
                  max: 5,
                  message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข'),
                },
                {
                  pattern: /^[0-9]+$/i,
                  message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น'),
                },
              ]}
            >
              <Input type="text" size="large" placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" />
            </Form.Item>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Helmet>
        <title>{'ควบคุมยอดตั้งสู้สมาชิก'}</title>
      </Helmet>
      <HasAccess roles={['Owner', 'Senior', 'Master', 'Agent']} permissions={['payrate-create']} renderAuthFailed={<ErrorPage404 />}>
        <Card
          title={
            <div style={{ padding: '20px 20px 10px 20px' }}>
              <h3
                style={{
                  color: '#0073e6', // Premium blue
                  margin: '0 0 12px 0',
                  fontSize: '22px',
                  fontWeight: 600,
                  borderBottom: '2px solid #00b894', // Soft green underline
                  paddingBottom: '12px',
                  lineHeight: 1.5,
                }}
              >
                ควบคุมยอดตั้งสู้สมาชิก
              </h3>
              <p
                style={{
                  color: '#d63031',
                  marginTop: '6px',
                  fontSize: '14px',
                  fontStyle: 'italic',
                  fontWeight: 500,
                }}
              >
                ** หากไม่ต้องการควบคุมยอดตั้งสู้สมาชิก ปล่อยให้เป็นช่องว่าง **
              </p>
            </div>
          }
        >
          <Form layout="vertical" autoComplete="off" onFinish={handleSubmit} form={form} initialValues={{}}>
            <Col span={isMobileView ? 24 : 24}>
              <Form.Item
                name="control_rate_lottery_type_id"
                label="ประเภทหวย"
                rules={[
                  {
                    required: true,
                    message: messageRequireIcon('กรุณากรอกข้อมูล ประเภทหวย'),
                  },
                ]}
              >
                <Select
                  placeholder="กรุณาเลือก ประเภทหวย"
                  onChange={(e, option: any) => {
                    setLotteryType(option?.value);
                  }}
                  disabled={id}
                >
                  {renderRoles()}
                </Select>
              </Form.Item>
            </Col>
            {renderDataTable()}

            <Row>
              <Col span={12}>
                <Link to="/backoffice/control_rate">
                  <Button type="text" htmlType="button" size="large" className="btn btn-md btn-secondary">
                    <ArrowLeftOutlined /> ย้อนกลับ
                  </Button>
                </Link>
              </Col>
              <Col span={12}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className="btn btn-md"
                  style={{ float: 'right' }}
                  disabled={dataCustomer?.length <= 0}
                >
                  <SaveOutlined /> {id ? 'อัปเดตข้อมูล' : `อัปเดตข้อมูล`}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </HasAccess>
    </>
  );
};

export default ControlRateCreate;
